<div class="checkbox-wrapper">
  <input
    [id]="id"
    type="checkbox"
    class="switch"
    [checked]="value"
    (change)="onChangeHandler($event)"
    (blur)="onTouched()"
  />
  <label [for]="id">{{ labelText }}</label>
</div>
